import featureClient1 from "../clients/buko/feature.json";
import featureClient4 from "../clients/johnnysniper/feature.json";
import featureClient2 from "../clients/labelle/feature.json";
import featureClient3 from "../clients/pushndrip/feature.json";
import featureClient5 from "../clients/veaesthetics/feature.json";
import { appConfig } from "./app.config";

export const appFeatureRecord = {
  ["buko"]: featureClient1,
  ["labelle"]: featureClient2,
  ["pushndrip"]: featureClient3,
  ["johnnysniper"]: featureClient4,
  ["veaesthetics"]: featureClient5
};
export const appFeature =
  appFeatureRecord[appConfig.client as keyof typeof appFeatureRecord];
